import * as React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { useEditorContext } from '../editor_context';

export const tiptapButtonStyle = {
   size: 'sm',
   mx: 'px',
   bgColor: 'gray.50',
   color: 'gray.500',
   outline: 'none',
   border: 'none',
   _hover: {
      bgColor: 'gray.100',
   },
   _focus: {
      bgColor: 'gray.100',
   },
   _active: {
      bgColor: 'gray.200',
   },
};

interface TiptapButtonProps {
   onClick: () => void;
   isActive?: boolean;
   isDisabled?: boolean;
   icon: React.ReactElement;
   title: string;
   shortcut?: string;
   overrideShortcut?: string;
   iconButtonStyle?: object;
}

export const TiptapButton = (props: TiptapButtonProps) => {
   // Label logic originally from prosemirror-example-setup/menu/menu.js
   const hasShortcut: boolean = Boolean(props.shortcut || props.overrideShortcut);
   const modKey = navigator.userAgent.indexOf('Mac') > 0 ? '⌘' : 'ctrl+';
   const shortcutText = props.overrideShortcut ?? `${modKey}${props.shortcut}`;
   const label = hasShortcut ? `${props.title} (${shortcutText})` : props.title;

   const { isActive, isDisabled, icon, title, iconButtonStyle } = props;
   const iconButtonProps = { isActive, isDisabled, icon, 'aria-label': title };

   const { editor } = useEditorContext();

   if (isDisabled) {
      return <IconButton {...tiptapButtonStyle} {...iconButtonStyle} {...iconButtonProps} />;
   } else {
      return (
         <Tooltip placement="top-start" label={label}>
            <IconButton
               {...tiptapButtonStyle}
               {...iconButtonStyle}
               {...iconButtonProps}
               onClick={e => {
                  e.preventDefault();
                  // Needed to fix an issue with Android keyboard losing focus
                  // https://github.com/ueberdosis/tiptap/issues/1806#issuecomment-1061167500
                  editor.view.focus();
                  props.onClick();
               }}
            />
         </Tooltip>
      );
   }
};
